import React from 'react';
import { X, Copy, Download } from 'lucide-react';

export const ErrorDebugModal = ({ error, context, onClose }) => {
  if (!error) return null;

  const debugInfo = {
    timestamp: new Date().toISOString(),
    error: {
      message: error.message,
      stack: error.stack,
      name: error.name
    },
    context: context,
    browser: navigator.userAgent,
    url: window.location.href,
    token: localStorage.getItem('token') ? 'Présent (masqué)' : 'Absent',
    user: localStorage.getItem('user')
  };

  const copyDebugInfo = () => {
    navigator.clipboard.writeText(JSON.stringify(debugInfo, null, 2));
    alert('✓ Informations copiées dans le presse-papier');
  };

  const downloadDebugInfo = () => {
    const blob = new Blob([JSON.stringify(debugInfo, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `debug-error-${Date.now()}.json`;
    a.click();
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="px-6 py-4 bg-red-50 border-b border-red-200 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-xl">!</span>
            </div>
            <div>
              <h2 className="text-lg font-heading font-semibold text-red-900">Erreur Détectée</h2>
              <p className="text-sm text-red-700">Informations de debug pour diagnostic</p>
            </div>
          </div>
          <button onClick={onClose} className="text-red-600 hover:text-red-800">
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Contenu */}
        <div className="flex-1 overflow-y-auto p-6">
          {/* Message erreur */}
          <div className="mb-6">
            <h3 className="font-semibold text-[#191D1E] mb-2">Message d'erreur</h3>
            <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-800 font-mono text-sm">{error.message}</p>
            </div>
          </div>

          {/* Contexte */}
          {context && (
            <div className="mb-6">
              <h3 className="font-semibold text-[#191D1E] mb-2">Contexte</h3>
              <div className="p-4 bg-[#F5F6F9] border border-[#BFC6CC] rounded-lg">
                <pre className="text-xs text-[#191D1E] overflow-x-auto">
                  {JSON.stringify(context, null, 2)}
                </pre>
              </div>
            </div>
          )}

          {/* Stack trace */}
          {error.stack && (
            <div className="mb-6">
              <h3 className="font-semibold text-[#191D1E] mb-2">Stack Trace</h3>
              <div className="p-4 bg-[#F5F6F9] border border-[#BFC6CC] rounded-lg">
                <pre className="text-xs text-[#687175] overflow-x-auto whitespace-pre-wrap">
                  {error.stack}
                </pre>
              </div>
            </div>
          )}

          {/* Debug Info complète */}
          <div>
            <h3 className="font-semibold text-[#191D1E] mb-2">Informations Système</h3>
            <div className="p-4 bg-[#F5F6F9] border border-[#BFC6CC] rounded-lg">
              <pre className="text-xs text-[#687175] overflow-x-auto">
                {JSON.stringify(debugInfo, null, 2)}
              </pre>
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="px-6 py-4 bg-[#F5F6F9] border-t border-[#BFC6CC] flex gap-3">
          <button
            onClick={copyDebugInfo}
            className="flex items-center gap-2 px-4 py-2 bg-[#397DFF] hover:bg-[#4672B6] text-white rounded-lg text-sm"
          >
            <Copy className="w-4 h-4" /> Copier Infos Debug
          </button>
          <button
            onClick={downloadDebugInfo}
            className="flex items-center gap-2 px-4 py-2 bg-[#191D1E] hover:bg-[#3C4649] text-white rounded-lg text-sm"
          >
            <Download className="w-4 h-4" /> Télécharger JSON
          </button>
          <button
            onClick={onClose}
            className="ml-auto px-4 py-2 border border-[#BFC6CC] text-[#687175] hover:bg-white rounded-lg text-sm"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};
